import { orderBy, has, deburr } from "lodash";
import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Paper } from "material-ui";
import CheckListTable from "../../components/CheckList/CheckListTable";
import {
	actionGetHomeStats,
	actionChangeBiModuleProps,
	actionGetChildrenStats
} from "../../actions/BIModuleActions";
import {
	actionChangeLocationProps,
	actionGetProvinces,
	actionGetCities
} from "../../actions/ProvinceActions";
// BI Module
import BiChart from "../../components/BiChart/BiChart";
import BaseClass from "./BaseClass";
import Data, { value } from "./DataLibrary";
import InputFiltroEmpresas from "./InputFiltroEmpresas";
// colores
import {
	C_DECLARADO,
	C_PAGADO,
	C_AFILIADOS,
	C_NO_AFILIADOS
} from "./DataConfig";
import { C_VERDE, C_VERDE_CLARO, C_ROJO, C_ROSA } from "./DataConfig";
// reducers para los datos
import {
	R_DeclaradoPagado,
	R_AfiliadosNoAfiliados_cant,
	R_HombresMujeresAfiliadosNoafiliados_cant,
	R_AfiliadoshombreAfiliadosmujer_cant,
	R_NOafiliadoshombreNOafiliadosmujer_cant
} from "./DataConfig";

// filtro x nombre de empresas
const FiltroxNombreEmpresa = (array, search) => {
	if (search === "") return array;
	return array.filter(
		item =>
			deburr(item.co.toUpperCase()).indexOf(search) !== -1 ? true : false
	);
};
// filtro x Company ID
const FiltroxCompanyId = (array, selectedItems) => {
	const objCompanyIds = {};
	for (let i in selectedItems) {
		const item = selectedItems[i];
		objCompanyIds[item.coId] = true;
	}
	return array.filter(item => objCompanyIds[item.coId]);
};
const FixNameLength = array => {
	for (let i in array) {
		let name = array[i]["name"];
		if (name.length > 23) {
			array[i]["name"] = name.substring(0, 20) + "...";
		}
	}
	return array;
};
const RoundFields = (array, fields) => {
	for (let index in array) {
		for (let key in array[index]) {
			if (fields.indexOf(key) >= 0) {
				array[index][key] = Math.floor(array[index][key]);
			}
		}
	}
	return array;
};

class indexEmpresas extends BaseClass {
	constructor(props) {
		super(props);
		// can not use setState() on constructor
		this.flagFistTime = true;
	}

	/*
   * Render functions
   */

	renderDeclaradoPagadoTotal(all_data) {
		const { year } = this.props.biModule;
		// proceso datos & defino colores
		let data = Data.reduce(all_data, R_DeclaradoPagado);
		data = RoundFields(data, ["value"]);
		const colors = {
			Declarado: C_DECLARADO,
			Pagado: C_PAGADO
		};
		return this.renderCard(
			`Total de DDJJ Declaradas / Pagadas (${year})`,
			<BiChart type="pie.alt" data={data} colors={colors} width={435} />
		);
	}
	renderDeclaradoPagadoxMes(all_data) {
		const { year } = this.props.biModule;
		// proceso datos & defino colores
		let data = Data.reduceByMonth(all_data, R_DeclaradoPagado);
		for (let i in data) {
			data[i]["Declarado"] = Math.floor(data[i]["Declarado"]);
			data[i]["Pagado"] = Math.floor(data[i]["Pagado"]);
			data[i]["Declarado"] = data[i]["Declarado"] + data[i]["Pagado"];
		}
		let colors = {
			Declarado: C_DECLARADO,
			Pagado: C_PAGADO
		};
		return this.renderCard(
			`Total de DDJJ Declaradas / Pagadas por mes (${year})`,
			<BiChart
				type="bar.stacked"
				data={data}
				colors={colors}
				Yunit=" $"
				width={435}
			/>
		);
	}
	renderDeclaradoPagado(homeStats) {
		const DeclaradoPagadoTotal = this.renderDeclaradoPagadoTotal(homeStats);
		const DeclaradoPagadoxMes = this.renderDeclaradoPagadoxMes(homeStats);
		return (
			<div className="columns-row-between" style={{ marginTop: "18px" }}>
				{DeclaradoPagadoTotal} {DeclaradoPagadoxMes}
			</div>
		);
	}

	renderAfiliadoNoAfiliadosTotal(all_data) {
		const { year } = this.props.biModule;
		// proceso datos & defino colores
		const data = Data.reduce(all_data, R_AfiliadosNoAfiliados_cant);
		const colors = {
			Afiliados: C_AFILIADOS,
			"No Afiliados": C_NO_AFILIADOS
		};
		return this.renderCard(
			`Total de Afiliados / No Afiliados en DDJJ (${year})`,
			<BiChart type="pie.alt" data={data} colors={colors} width={435} />
		);
	}
	renderAfiliadoNoAfiliadosxMes(all_data) {
		const { year } = this.props.biModule;
		// proceso datos & defino colores
		const data = Data.reduceByMonth(all_data, R_AfiliadosNoAfiliados_cant);
		const colors = {
			Afiliados: C_AFILIADOS,
			"No Afiliados": C_NO_AFILIADOS
		};
		return this.renderCard(
			`Cantidad de Afiliados / No Afiliados por mes en DDJJ (${year})`,
			<BiChart type="bar.stacked" data={data} colors={colors} width={435} />
		);
	}
	renderAfiliadoNoAfiliados(homeStats) {
		const AfiliadoNoAfiliadosTotal = this.renderAfiliadoNoAfiliadosTotal(
			homeStats
		);
		const AfiliadoNoAfiliadosxMes = this.renderAfiliadoNoAfiliadosxMes(
			homeStats
		);
		return (
			<div className="columns-row-between" style={{ marginTop: "18px" }}>
				{AfiliadoNoAfiliadosTotal} {AfiliadoNoAfiliadosxMes}
			</div>
		);
	}

	renderTop10Empleados(all_data, sinFiltro) {
		const { year } = this.props.biModule;
		// proceso datos & defino colores
		const tmp1 = Data.reduceByCompany(
			all_data,
			R_HombresMujeresAfiliadosNoafiliados_cant
		);
		const tmp2 = orderBy(
			tmp1,
			[
				function(row) {
					return (
						row["Afiliados Hombres"] +
						row["Afiliados Mujeres"] +
						row["No Afiliados Hombres"] +
						row["No Afiliados Mujeres"]
					);
				}
			],
			["desc"]
		);
		let data = tmp2.length > 9 ? tmp2.slice(0, 10) : tmp2;
		data = FixNameLength(data);
		let colors = {
			"Afiliados Hombres": C_VERDE,
			"Afiliados Mujeres": C_VERDE_CLARO,
			"No Afiliados Hombres": C_ROJO,
			"No Afiliados Mujeres": C_ROSA
		};
		const label = sinFiltro ? `Top 10 empresas` : `Selección`;
		return this.renderCard(
			`${label} con mascantidad de empleados (${year})`,
			<BiChart
				type="bar.vertical"
				data={data}
				colors={colors}
				width={900}
				YAxisWidth={250}
				YAxisInterval={0}
			/>
		);
	}
	renderTop10Afiliados(all_data, sinFiltro) {
		const { year } = this.props.biModule;
		// proceso datos & defino colores
		const tmp1 = Data.reduceByCompany(
			all_data,
			R_AfiliadoshombreAfiliadosmujer_cant
		);
		const tmp2 = orderBy(
			tmp1,
			[
				function(row) {
					return row["Afiliados Hombres"] + row["Afiliados Mujeres"];
				}
			],
			["desc"]
		);
		let data = tmp2.length > 9 ? tmp2.slice(0, 10) : tmp2;
		data = FixNameLength(data);
		let colors = {
			"Afiliados Hombres": C_VERDE,
			"Afiliados Mujeres": C_VERDE_CLARO
		};
		const label = sinFiltro ? `Top 10 empresas` : `Selección`;
		return this.renderCard(
			`${label} con mas cantidad de Afiliados (${year})`,
			<BiChart
				type="bar.vertical"
				data={data}
				colors={colors}
				width={900}
				YAxisWidth={250}
				YAxisInterval={0}
			/>
		);
	}
	renderTop10NoAfiliados(all_data, sinFiltro) {
		const { year } = this.props.biModule;
		// proceso datos & defino colores
		const tmp1 = Data.reduceByCompany(
			all_data,
			R_NOafiliadoshombreNOafiliadosmujer_cant
		);
		const tmp2 = orderBy(
			tmp1,
			[
				function(row) {
					return row["No Afiliados Hombres"] + row["No Afiliados Mujeres"];
				}
			],
			["desc"]
		);
		let data = tmp2.length > 9 ? tmp2.slice(0, 10) : tmp2;
		data = FixNameLength(data);
		let colors = {
			"No Afiliados Hombres": C_ROJO,
			"No Afiliados Mujeres": C_ROSA
		};
		const label = sinFiltro ? `Top 10 empresas` : `Selección`;
		return this.renderCard(
			`${label} con mas cantidad de NO Afiliados (${year})`,
			<BiChart
				type="bar.vertical"
				data={data}
				colors={colors}
				width={900}
				YAxisWidth={250}
				YAxisInterval={0}
			/>
		);
	}
	renderTop10ImporteDeclaradoPagado(all_data, sinFiltro) {
		const { year } = this.props.biModule;
		// proceso datos & defino colores
		let tmp1 = Data.reduceByCompany(all_data, R_DeclaradoPagado);
		let tmp2 = orderBy(
			tmp1,
			[
				function(row) {
					return row["Declarado"] + row["Pagado"];
				}
			],
			["desc"]
		);
		let data = tmp2.length > 9 ? tmp2.slice(0, 10) : tmp2;
		data = FixNameLength(data);
		const colors = {
			Declarado: C_DECLARADO,
			Pagado: C_PAGADO
		};
		const label = sinFiltro ? `Top 10 empresas` : `Selección`;
		return this.renderCard(
			`${label} con mas importe Declarado / Pagado (${year})`,
			<BiChart
				type="bar.vertical"
				data={data}
				colors={colors}
				Xunit=" $"
				width={900}
				YAxisWidth={250}
				YAxisInterval={0}
			/>
		);
	}
	renderTop10(homeStats, sinFiltro) {
		const top10Empleados = this.renderTop10Empleados(homeStats, sinFiltro);
		const top10Afiliados = this.renderTop10Afiliados(homeStats, sinFiltro);
		const top10NoAfiliados = this.renderTop10NoAfiliados(homeStats, sinFiltro);
		const top10DeclaradoPagado = this.renderTop10ImporteDeclaradoPagado(
			homeStats,
			sinFiltro
		);
		return (
			<div>
				<div className="columns-row-between" style={{ marginTop: "18px" }}>
					{top10DeclaradoPagado}
				</div>
				<div className="columns-row-between" style={{ marginTop: "18px" }}>
					{top10Empleados}
				</div>
				<div className="columns-row-between" style={{ marginTop: "18px" }}>
					{top10Afiliados}
				</div>
				<div className="columns-row-between" style={{ marginTop: "18px" }}>
					{top10NoAfiliados}
				</div>
			</div>
		);
	}

	// funcion interna para filtrar datos x nombre de empresa
	filtroDatosEmpresas(myArray, search = "") {
		// filtro x nombre de empresa
		myArray = search !== "" ? FiltroxNombreEmpresa(myArray, search) : myArray;
		// reduzco al formato que necesito
		let myObject = myArray.reduce((retval, item) => {
			const aportes =
				value("data.NA$.f", item) +
				value("data.NA$.m", item) +
				value("data.A$.f", item) +
				value("data.A$.m", item);
			if (!has(retval, item.co)) {
				retval[item.co] = {
					co: item.co,
					coId: item.coId,
					ddjj: item.ddjj,
					aportes: aportes,
					paid: item.paid
				};
			} else {
				retval[item.co]["ddjj"] += item.ddjj;
				retval[item.co]["aportes"] += aportes;
				retval[item.co]["paid"] += item.paid;
			}
			return retval;
		}, {});
		// preparo el array para retornar
		let retval = [];
		for (let key in myObject) {
			retval.push(myObject[key]);
		}
		return retval;
	}
	renderFiltroEmpresas(data) {
		const onChangeCheckList = selectedItems => this.setState({ selectedItems });
		const seach = deburr(this.state.search).toUpperCase();
		const items = this.filtroDatosEmpresas(data, seach);
		const grid = {
			items: items,
			pageSize: 10,
			total: items.length,
			fetchingData: this.state.fetchingData
		};
		const checks = {
			checkId: "coId",
			onChangeCheckList: onChangeCheckList,
			selectedItems: this.state.selectedItems,
			selectAllItems: true
		};
		const display = {
			co: {
				header: "Empresa",
				render: item => `${item.co}`,
				style: { width: "50%" }
			},
			ddjj: {
				header: "Cant DDJJ",
				render: item => `${item.ddjj}`,
				style: { textAlign: "right" }
			},
			aportes: {
				header: "($) Declarado",
				render: item => `${item.aportes}`,
				style: { textAlign: "right" }
			},
			paid: {
				header: "($) Pagado",
				render: item => `${item.paid}`,
				style: { textAlign: "right" }
			}
		};
		return this.renderCard(
			<InputFiltroEmpresas
				placeholder="buscar por empresa..."
				onChange={search => this.setState({ search })}
			/>,
			<CheckListTable grid={grid} display={display} checks={checks} />,
			{ flex: 4 }
		);
	}

	render() {
		// datos
		const { selectedItems = [] } = this.state;
		let homeStats = this.getHomeStats();
		// filtro por company id
		let homeStatsFiltrado = [];
		if (selectedItems.length > 0) {
			homeStatsFiltrado = FiltroxCompanyId(homeStats, selectedItems);
		}
		// genero html
		const htmlHeader = this.renderHeaderReport({ title: "Empresas" });
		const sinFiltro =
			homeStats.length === homeStatsFiltrado.length ? true : false;
		const htmlFiltroEmpresas = this.renderFiltroEmpresas(homeStats);
		const htmlDeclaradoPagado = this.renderDeclaradoPagado(homeStatsFiltrado);
		const htmlAfiliadoNoAfiliados = this.renderAfiliadoNoAfiliados(
			homeStatsFiltrado
		);
		const htmlTop10 = this.renderTop10(homeStatsFiltrado, sinFiltro);
		let mapa = this.renderMapaArgentina({
			type: "card",
			title: "Filtre por provincia"
		}); //[paper,card,null]
		// all done
		return (
			<Paper zDepth={2} style={{ padding: "30px", marginBottom: "30px" }}>
				{htmlHeader}
				<div style={{ display: "flex", flexDirection: "row" }}>
					<div style={{ marginTop: "18px", width: "870px" }}>
						{htmlFiltroEmpresas}
					</div>
					<div style={{ flex: 1, marginLeft: "5px" }}>{mapa}</div>
				</div>
				{htmlDeclaradoPagado}
				{htmlAfiliadoNoAfiliados}
				{htmlTop10}
			</Paper>
		);
	}
}

function mapStateToProps(store) {
	const provincias = Data.reduceToObject(
		store.locations.provinciasList,
		"id",
		row => row.name
	);
	const biModule = Object.assign({}, store.biModule, { provincias });
	return {
		biModule: biModule,
		provincias: store.locations.provinciasList,
		ciudades: store.locations.ciudadesList,
		session: store.session,
		login: store.session.authenticated,
		rol: store.app.rol
	};
}
function mapDispatchToProps(dispatch) {
	return bindActionCreators(
		{
			actionGetHomeStats,
			actionChangeBiModuleProps,
			actionGetChildrenStats,
			actionChangeLocationProps,
			actionGetProvinces,
			actionGetCities
		},
		dispatch
	);
}
export default connect(mapStateToProps, mapDispatchToProps)(indexEmpresas);



// WEBPACK FOOTER //
// ./src/screens/biCharts/indexEmpresas.js